import { Box, MenuItem } from '@mui/material';
import {
  CustomTextField,
  CustomSelect,
  HorizontalForm,
  VerticalForm,
  DialogTitle,
} from '../../../common';

const ContactDataSection = ({
  selectedLegalEntity,
  onInputChange,
  onSelectChange,
  isMobile,
  editMode,
  countries,
  provinces,
  departments,
  districts,
  locationState,
}) => {
  const getFilteredProvinces = () => {
    const countryUuid = editMode
      ? locationState.country?.uuid
      : selectedLegalEntity.uuid_country;

    return provinces.filter((prov) => prov.uuid_country === countryUuid);
  };

  const getFilteredDepartments = () => {
    const provinceUuid = editMode
      ? locationState.province?.uuid
      : selectedLegalEntity.uuid_province;

    return departments.filter((dep) => dep.uuid_province === provinceUuid);
  };

  const getFilteredDistricts = () => {
    const departmentUuid = editMode
      ? locationState.department?.uuid
      : selectedLegalEntity.uuid_department;

    return districts.filter((dist) => dist.uuid_department === departmentUuid);
  };

  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos de contacto
      </DialogTitle>
      {isMobile ? (
        <VerticalForm>
          <CustomTextField
            label="Dirección"
            name="address"
            value={selectedLegalEntity.address || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="CP"
            name="postal_code"
            value={selectedLegalEntity.postal_code || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Teléfono"
            name="phone_number"
            value={selectedLegalEntity.phone_number || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Correo Electrónico"
            name="email"
            value={selectedLegalEntity.email || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomSelect
            label="País"
            name="uuid_country"
            value={
              editMode ? locationState.country?.uuid || '' : selectedLegalEntity.uuid_country || ''
            }
            onChange={onSelectChange}
            disabled={editMode}
            size="medium"
          >
            {countries.map((country) => (
              <MenuItem key={country.uuid} value={country.uuid}>
                {country.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Provincia"
            name="uuid_province"
            value={
              editMode
                ? locationState.province?.uuid || ''
                : selectedLegalEntity.uuid_province || ''
            }
            onChange={onSelectChange}
            disabled={editMode || !selectedLegalEntity.uuid_country}
            size="medium"
          >
            {getFilteredProvinces().map((prov) => (
              <MenuItem key={prov.uuid} value={prov.uuid}>
                {prov.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Departamento"
            name="uuid_department"
            value={
              editMode
                ? locationState.department?.uuid || ''
                : selectedLegalEntity.uuid_department || ''
            }
            onChange={onSelectChange}
            disabled={editMode || !selectedLegalEntity.uuid_province}
            size="medium"
          >
            {getFilteredDepartments().map((dep) => (
              <MenuItem key={dep.uuid} value={dep.uuid}>
                {dep.name}
              </MenuItem>
            ))}
          </CustomSelect>
          <CustomSelect
            label="Distrito"
            name="uuid_district"
            value={
              editMode
                ? locationState.district?.uuid || ''
                : selectedLegalEntity.uuid_district || ''
            }
            onChange={onSelectChange}
            disabled={!editMode && !selectedLegalEntity.uuid_department}
            size="medium"
          >
            {getFilteredDistricts().map((dist) => (
              <MenuItem key={dist.uuid} value={dist.uuid}>
                {dist.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </VerticalForm>
      ) : (
        <HorizontalForm withBorder={false} sx={{ p: 1 }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
            <CustomTextField
              label="Dirección"
              name="address"
              value={selectedLegalEntity.address || ''}
              onChange={onInputChange}
              size="medium"
            />
            <CustomTextField
              label="CP"
              name="postal_code"
              value={selectedLegalEntity.postal_code || ''}
              onChange={onInputChange}
              size="medium"
            />
            <CustomTextField
              label="Teléfono"
              name="phone_number"
              value={selectedLegalEntity.phone_number || ''}
              onChange={onInputChange}
              size="medium"
            />
            <CustomTextField
              label="Correo Electrónico"
              name="email"
              value={selectedLegalEntity.email || ''}
              onChange={onInputChange}
              size="medium"
            />
          </Box>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <CustomSelect
              label="País"
              name="uuid_country"
              value={
                editMode
                  ? locationState.country?.uuid || ''
                  : selectedLegalEntity.uuid_country || ''
              }
              onChange={onSelectChange}
              disabled={editMode}
              size="medium"
            >
              {countries.map((country) => (
                <MenuItem key={country.uuid} value={country.uuid}>
                  {country.name}
                </MenuItem>
              ))}
            </CustomSelect>
            <CustomSelect
              label="Provincia"
              name="uuid_province"
              value={
                editMode
                  ? locationState.province?.uuid || ''
                  : selectedLegalEntity.uuid_province || ''
              }
              onChange={onSelectChange}
              disabled={editMode || !selectedLegalEntity.uuid_country}
              size="medium"
            >
              {getFilteredProvinces().map((prov) => (
                <MenuItem key={prov.uuid} value={prov.uuid}>
                  {prov.name}
                </MenuItem>
              ))}
            </CustomSelect>
            <CustomSelect
              label="Departamento"
              name="uuid_department"
              value={
                editMode
                  ? locationState.department?.uuid || ''
                  : selectedLegalEntity.uuid_department || ''
              }
              onChange={onSelectChange}
              disabled={editMode || !selectedLegalEntity.uuid_province}
              size="medium"
            >
              {getFilteredDepartments().map((dep) => (
                <MenuItem key={dep.uuid} value={dep.uuid}>
                  {dep.name}
                </MenuItem>
              ))}
            </CustomSelect>
            <CustomSelect
              label="Distrito"
              name="uuid_district"
              value={
                editMode
                  ? locationState.district?.uuid || ''
                  : selectedLegalEntity.uuid_district || ''
              }
              onChange={onSelectChange}
              disabled={!editMode && !selectedLegalEntity.uuid_department}
              size="medium"
            >
              {getFilteredDistricts().map((dist) => (
                <MenuItem key={dist.uuid} value={dist.uuid}>
                  {dist.name}
                </MenuItem>
              ))}
            </CustomSelect>
          </Box>
        </HorizontalForm>
      )}
    </Box>
  );
};

export default ContactDataSection;
